<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش سفارشات تکراری</h5>
        <div style="flex: 1"></div>
        <ExcelDownload
          :url="
            `/admin/reports/duplicate-orders-new?start_date=${filterDate.startDate}&end_date=${filterDate.endDate}`
          "
        />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12">
          <DatePickerRange class="col-md-6" v-model="filterDate" />
        </div>
        <b-button
          class="col-md-2 mt-3 mr-5"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
      <b-table
            responsive
            hover
            bordered
            :items="reports"
            :tbody-tr-class="rowClass"
            :fields="fields"
          >
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
            <template v-slot:cell(mobile)="data">
              {{ data.item.customer.mobile}}
            </template>
            <template v-slot:cell(cash_amount)="data">
              {{ data.item.cash_amount | price }}
            </template>
            <template v-slot:cell(pos_price)="data">
              {{ data.item.pos_price | price }}
            </template>
            <template v-slot:cell(cardByCard_amount)="data">
              {{ data.item.cardByCard_amount | price }}
            </template>
            <template v-slot:cell(from_wallet_amount)="data">
              {{ data.item.from_wallet_amount | price }}
            </template>
            <template v-slot:cell(remainder)="data">
              {{ data.item.remainder | price }}
            </template>
            <template v-slot:cell(sum_refund)="data">
              {{ data.item.sum_refund | price }}
            </template>
            <template v-slot:cell(total_two)="data">
              {{ data.item.total_two.toLocaleString() }}
            </template>
            <template v-slot:cell(gift_coupon)="data">
              {{
                data.item.sum_discounts | price
              }}
            </template>
            <template v-slot:cell(type)="data">
              <span
                v-if="data.item.type == 'increment'"
                class="badge badge-success status"
                >افزایش</span
              >
              <span v-else class="badge badge-danger status">کاهش</span>
            </template>
            <template v-slot:cell(total)="data">
              <span v-if="data.item.total >= 0" class="text-success">
                {{ data.item.total | price }}
              </span>
              <span v-else style="direction: ltr" dir="ltr" class="text-danger"
                >-{{ data.item.total | price }}</span
              >
            </template>
          </b-table>
        <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>

    <div class="modal fade" id="showModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content modal-content-demo">
          <div class="modal-header">
            <p class="modal-title font-weight-bold">توضیحات آیتم</p>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <b>توضیحات:</b>
              <p class="mr-2">{{ orderDescription }}</p>
            </div>
            <div class="modal-footer justify-content-center">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BButton,
  BTd,
  BFormCheckbox,
} from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload.vue";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "SinglePurchaseNew",
  components: {
    BTable,
    ExcelDownload,
    BFormGroup,
    BFormInput,
    BButton,
    BTd,
    DatePickerRange,
    BFormCheckbox,
  },
  configProvider,
  data() {
    return {
      disabled: false,
     fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "mobile",
          label: "مشتری",
        },
        {
          key: "mini_order_items_count",
          label: "آیتم ها",
        },
            {
          key: "total",
          label: "جمع کل",
        },
        {
          key: "cash_amount",
          label: "نقدی",
        },
        {
          key: "cardByCard_amount",
          label: "از کارت",
        },
        {
          key: "from_wallet_amount",
          label: "کیف پول",
        },
        {
          key: "gift_coupon",
          label: "تخفیف",
        },
        {
          key: "remainder",
          label: "مبلغ باقی مانده",
        },
        {
          key: "sum_refund",
          label: "مرجوعی",
        },
        {
          key: "pos_price",
          label: "از پوز",
        },
        {
          key: "total_two",
          label: "مبلغ نهایی",
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
        },
      ],
      page: 1,
      reports: null,
      totals: null,
      selectedStore: null,
      orderDescription: "",
      stores: [],
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filter: new Filter(),
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],
  mounted() {
    this.loadStores();
  },
  methods: {
    resetFilter() {
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    async loadStores() {
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
        this.disabled = false;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    openModal(invoice_number) {
      this.orderDescription = this.reports.find(
        (report) => report.invoice_number === invoice_number,
      ).description;
      $("#showModal").modal("show");
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/reports/duplicate-orders-new",
          {
            params: {
              start_date: this.filterDate.startDate,
              end_date: this.filterDate.endDate,
            },
          },
        );
        this.reports = response.data.data.mini_orders;
        // this.totals = response.data.data.totals;
        console.log(this.reports, "this.reports");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
